const FormBlock = ({
  label,
  name,
  value,
  update,
  isRequired,
  type,
  step,
  placeholder,
  max
}) => {
  return (
    <div className="form-block">
      <label className={`input-label ${isRequired ? "required" : ""}`}>
        {label}
      </label>
      <div className="input-cont">
        <input
          className="text-input with-border"
          type={type || "text"}
          name={name}
          value={value}
          onChange={update}
          required={isRequired}
          min={0}
          max={max || Number.MAX_SAFE_INTEGER}
          step={step ? step : undefined}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default FormBlock;